import { render, staticRenderFns } from "./measurement.vue?vue&type=template&id=1bb1a6e3&"
import script from "./measurement.vue?vue&type=script&lang=js&"
export * from "./measurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "measurement.vue"
export default component.exports